import { render, staticRenderFns } from "./ThanksFooter.vue?vue&type=template&id=5d0238b6&"
import script from "./ThanksFooter.vue?vue&type=script&lang=js&"
export * from "./ThanksFooter.vue?vue&type=script&lang=js&"
import style0 from "./ThanksFooter.vue?vue&type=style&index=0&id=5d0238b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports